module.exports = require('./eruda').default

//# sourceMappingURL=index.js.map
